import { useState } from "react";
import { object, func, bool } from "prop-types";
import { connect } from "react-redux";

import {
  onboardUpdateState,
  updateCvInProfileSilent,
  clearErrors,
} from "../redux/actions";

import history from "../history";
import { trackOnboardingStep } from "../helpers/productMetrics";

const useUploadState = () => {
  const initialState = {
    isFileSelected: false,
    selectedFile: null,
    fileName: "",
    validationError: "",
  };
  const [state, setState] = useState(initialState);

  const validateCvFile = (file) => {
    const allowedExtensions = ["doc", "docx", "pdf"];
    if (file) {
      if (file.size === 0) {
        return "fileEmpty";
      }
      const fileNameParts = file.name.split(".");
      const extension = fileNameParts[fileNameParts.length - 1].toLowerCase();
      if (!allowedExtensions.includes(extension) || !file.name.includes(".")) {
        return "formatInvalid";
      }
    }
    return "";
  };

  const selectFile = (e) =>
    setState({
      selectedFile: e.target.files ? e.target.files[0] : "",
      fileName: e.target.files ? e.target.files[0].name : "",
      isFileSelected: !!e.target.files,
      validationError: e.target.files ? validateCvFile(e.target.files[0]) : "",
    });

  return [state, selectFile];
};

const CvUpload = ({
  appData,
  isOnboarding = false,
  onboardState,
  onboardUpdateState: updateOnboard,
  isCvLoading,
  updateProfile,
  children,
  errors,
  clearErrorsWithSource,
}) => {
  const [
    { selectedFile, isFileSelected, fileName, validationError },
    selectFile,
  ] = useUploadState();

  const { candidateRef, emailAddress } = appData || {};
  const userData = { candidateRef, emailAddress };

  const handleSubmit = (file) => {
    const updatedUserData = {
      ...userData,
      cvFile: file || selectedFile,
    };

    return Promise.all([
      updateProfile(candidateRef, updatedUserData),
      updateOnboard({ ...onboardState, basic: true, cv: true }),
      isOnboarding && trackOnboardingStep("CV Upload"),
      isOnboarding && history.push("/onboard/work-type"),
    ]);
  };

  const uploadAndSave = (e) => {
    const updatedUserData = {
      ...userData,
      cvFile: e.target.files[0],
    };

    return Promise.all([
      updateProfile(candidateRef, updatedUserData),
      updateOnboard({ ...onboardState, basic: true, cv: true }),
    ]);
  };

  return children({
    appData,
    isFileSelected,
    fileName,
    selectFile,
    handleSubmit,
    uploadAndSave,
    isCvLoading,
    validationError,
    errors,
    clearErrorsWithSource,
  });
};

CvUpload.propTypes = {
  appData: object,
  updateProfile: func.isRequired,
  onboardState: object.isRequired,
  onboardUpdateState: func.isRequired,
  children: func.isRequired,
  isCvLoading: bool.isRequired,
};

const mapStateToProps = (state) => ({
  appData: state.core.app || {},
  onboardState: state.core.onboardState,
  isCvLoading: !!state.core.isCvLoading,
  errors: state.core.errors,
});

const mapDispatchToProps = {
  onboardUpdateState,
  updateProfile: updateCvInProfileSilent,
  clearErrorsWithSource: clearErrors,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(CvUpload);
